import Company from '@/models/Company';
import Project from '@/models/Project';
import CompanyService from '@/services/CompanyService';
import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';

export const useCompaniesStore = defineStore('companies', {
  state: () => ({}),

  getters: {
    models: () => useRepo(Company),
  },

  actions: {
    async index() {
      const [data, error] = await CompanyService.index();

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async fetchAdminIndex(page = 1) {
      const [data, error] = await CompanyService.adminIndex(page);

      if(error) {
        throw error;
      }

      this.models.flush();
      this.models.save(data.companies.data);

      return data;
    },

    async fetchAdminCompany(id: Id) {
      const [data, error] = await CompanyService.adminShow(id);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async updateAdminCompany(id: Id, request: ApiRequests['api.v1.admin.companies.update']) {
      const [data, error] = await CompanyService.adminUpdate(id, request);

      if(error) {
        throw error;
      }

      const projectRepo = useRepo(Project);

      projectRepo.flush();
      this.models.save(data);

      return data;
    },

    async createCompany(request: ApiRequests['api.v1.admin.companies.store']) {
      const [data, error] = await CompanyService.create(request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async updateCompany(id: Id, request: ApiRequests['api.v1.companies.update']) {
      const [data, error] = await CompanyService.update(id, request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async deleteCompany(id: Id) {
      const [data, error] = await CompanyService.delete(id);

      if(error) {
        throw error;
      }

      this.models.destroy(id);

      return data;
    },

    async storeLogo(id: Id, form: ApiRequests['api.v1.companies.logo.store'] | FormData) {
      const [data, error] = await CompanyService.logo.store(id, form);

      if(error) {
        throw error;
      }

      return data;
    },

    async showLogo(id: Id, projectId?: Id) {
      const [data, error] = await CompanyService.logo.show(id, projectId);

      if(error) {
        throw error;
      }

      return data;
    },
  },
});
